<template>
    <div>
        <div class="count-container">
            <!--        <img src="@/assets/welcome.png" alt="" class="welcome-bg">-->
            <div class="count-item">
                <h1>{{stuCount}}</h1>
                <h2>
                    <i class="el-icon-user"></i>
                    学生
                </h2>
            </div>
            <div class="count-item">
                <h1>{{crCount}}</h1>
                <h2>
                    <i class="el-icon-school"></i>
                    班级
                </h2>
            </div>
            <div class="count-item">
                <h1>{{videoCount}}</h1>
                <h2>
                    <i class="el-icon-video-camera"></i>
                    视频
                </h2>
            </div>
            <div class="count-item">
                <h1>{{epmCount}}</h1>
                <h2>
                    <i class="el-icon-tickets"></i>
                    招聘信息
                </h2>
            </div>
        </div>
        <div class="charts-container">
            <div class="charts-item">
                <p class="charts-title">今日学霸（分钟）</p>
                <div ref="mLearnRecord" class="learn-recode"></div>
            </div>
            <div class="charts-item">
                <p class="charts-title">{{this.year}}年在线学习记录（分钟）</p>
                <div ref="yLearnRecord" class="learn-recode"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Welcome",
        created() {
            this.getData();
        },
        data() {
            let date = new Date();
            return {
                apiUrl: process.env.VUE_APP_URL,
                month: date.getMonth() + 1,
                year: date.getFullYear(),
                stuCount: 0,
                crCount: 0,
                videoCount: 0,
                epmCount: 0,
                top10X: ['暂无', '暂无', '暂无', '暂无', '暂无', '暂无', '暂无', '暂无', '暂无', '暂无'],
                top10Y: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                yearLearnY: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
        },
        methods: {
            initTop10Charts() {
                let dom = this.$refs['mLearnRecord'];
                let myChart = echarts.init(dom);
                let option = {
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            interval: 0,//0:显示所有标签，n:间隔n个标签显示
                            // rotate: 45
                        },
                        data: this.top10X
                    },
                    yAxis: {
                        type: 'value'
                    },
                    grid: {
                        right: '9%',
                        top: '5%'
                    },
                    series: [{
                        data: this.top10Y,
                        type: 'bar',
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        }
                    }]
                };
                if (option && typeof option === "object") {
                    myChart.setOption(option, true);
                }
            },
            initYearCharts() {
                let dom = this.$refs['yLearnRecord'];
                let myChart = echarts.init(dom);
                let option = {
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            interval: 0,//0:显示所有标签，n:间隔n个标签显示
                            // rotate: 45
                        },
                        data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    grid: {
                        right: '9%',
                        top: '5%'
                    },
                    series: [{
                        data: this.yearLearnY,
                        type: 'line',
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        }
                    }]
                };
                if (option && typeof option === "object") {
                    myChart.setOption(option, true);
                }
            },
            getData() {
                let stuUrl = this.apiUrl + "ma/student/count";
                let crUrl = this.apiUrl + "ma/classroom/count";
                let videoUrl = this.apiUrl + "ma/video/count";
                let epmUrl = this.apiUrl + "ma/employment/count";
                let todayTop10Url = this.apiUrl + "ma/LearnRecord/getTodayTop10";
                let learnRecordByYear = this.apiUrl + "ma/LearnRecord/getLearnRecordByYear";

                this.$axios.post(stuUrl).then(({data}) => {
                    if (data.code === 200) this.stuCount = data.message;
                });
                this.$axios.post(crUrl).then(({data}) => {
                    if (data.code === 200) this.crCount = data.message;
                });
                this.$axios.post(videoUrl).then(({data}) => {
                    if (data.code === 200) this.videoCount = data.message;
                });
                this.$axios.post(epmUrl).then(({data}) => {
                    if (data.code === 200) this.epmCount = data.message;
                });
                this.$axios.post(todayTop10Url).then(({data}) => {
                    if (data.code === 200) {
                        let ls = JSON.parse(data.message);
                        ls.forEach((v, i) => {
                            this.top10X[i] = v.name;
                            this.top10Y[i] = Math.ceil(v.sum / 60);
                        });
                        this.initTop10Charts();
                    }
                });
                this.$axios.post(learnRecordByYear).then(({data}) => {
                    if (data.code === 200) {
                        let ls = JSON.parse(data.message);
                        ls.forEach((v, i) => {
                            this.yearLearnY[v.month - 1] = Math.ceil(v.sum / 60);
                        });
                        this.initYearCharts();
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .learn-recode {
        height: calc(100vh - 333px);
    }

    .welcome-bg {
        width: 100%;
    }

    .charts-item {
        flex: 1;
    }

    .count-container, .charts-container {
        display: flex;
    }

    .count-item {
        height: 155px;
        flex: 1;
        text-align: center;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        /*border-radius: 5px;
        margin: 0 10px;*/
    }

    .count-item h1 {
        color: #6f6f6f;
        font-size: 3em;
    }

    .count-item h2, .charts-title {
        color: #4f4f4f;
        font-weight: normal;
        font-size: 1.1em;
        text-align: center;
    }

    .charts-title {
        font-size: 1.2em;
        color: #6f6f6f;
        margin-top: 20px;
        font-weight: bold;
    }
</style>